/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { createCustomFieldsSchema } from '../fn/custom-fields-schema/create-custom-fields-schema';
import { CreateCustomFieldsSchema$Params } from '../fn/custom-fields-schema/create-custom-fields-schema';
import { CustomFieldsSchemaDto } from '../models/custom-fields-schema-dto';
import { CustomFieldsSchemaDtoPage } from '../models/custom-fields-schema-dto-page';
import { getCustomFieldsSchema } from '../fn/custom-fields-schema/get-custom-fields-schema';
import { GetCustomFieldsSchema$Params } from '../fn/custom-fields-schema/get-custom-fields-schema';
import { listCustomFieldsSchema } from '../fn/custom-fields-schema/list-custom-fields-schema';
import { ListCustomFieldsSchema$Params } from '../fn/custom-fields-schema/list-custom-fields-schema';
import { updateCurrentCustomFieldsSchema } from '../fn/custom-fields-schema/update-current-custom-fields-schema';
import { UpdateCurrentCustomFieldsSchema$Params } from '../fn/custom-fields-schema/update-current-custom-fields-schema';

@Injectable({ providedIn: 'root' })
export class CustomFieldsSchemaApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `listCustomFieldsSchema()` */
  static readonly ListCustomFieldsSchemaPath = '/v0/CustomFieldsSchema';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listCustomFieldsSchema()` instead.
   *
   * This method doesn't expect any request body.
   */
  listCustomFieldsSchema$Response(params?: ListCustomFieldsSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomFieldsSchemaDtoPage>> {
    return listCustomFieldsSchema(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listCustomFieldsSchema$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listCustomFieldsSchema(params?: ListCustomFieldsSchema$Params, context?: HttpContext): Observable<CustomFieldsSchemaDtoPage> {
    return this.listCustomFieldsSchema$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomFieldsSchemaDtoPage>): CustomFieldsSchemaDtoPage => r.body)
    );
  }

  /** Path part for operation `getCustomFieldsSchema()` */
  static readonly GetCustomFieldsSchemaPath = '/v0/CustomFieldsSchema/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCustomFieldsSchema()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomFieldsSchema$Response(params: GetCustomFieldsSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomFieldsSchemaDto>> {
    return getCustomFieldsSchema(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCustomFieldsSchema$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCustomFieldsSchema(params: GetCustomFieldsSchema$Params, context?: HttpContext): Observable<CustomFieldsSchemaDto> {
    return this.getCustomFieldsSchema$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomFieldsSchemaDto>): CustomFieldsSchemaDto => r.body)
    );
  }

  /** Path part for operation `createCustomFieldsSchema()` */
  static readonly CreateCustomFieldsSchemaPath = '/v0/CustomFieldsSchema/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createCustomFieldsSchema()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createCustomFieldsSchema$Response(params: CreateCustomFieldsSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomFieldsSchemaDto>> {
    return createCustomFieldsSchema(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createCustomFieldsSchema$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createCustomFieldsSchema(params: CreateCustomFieldsSchema$Params, context?: HttpContext): Observable<CustomFieldsSchemaDto> {
    return this.createCustomFieldsSchema$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomFieldsSchemaDto>): CustomFieldsSchemaDto => r.body)
    );
  }

  /** Path part for operation `updateCurrentCustomFieldsSchema()` */
  static readonly UpdateCurrentCustomFieldsSchemaPath = '/v0/CustomFieldsSchema/{id}/current';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCurrentCustomFieldsSchema()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCurrentCustomFieldsSchema$Response(params: UpdateCurrentCustomFieldsSchema$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomFieldsSchemaDto>> {
    return updateCurrentCustomFieldsSchema(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCurrentCustomFieldsSchema$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCurrentCustomFieldsSchema(params: UpdateCurrentCustomFieldsSchema$Params, context?: HttpContext): Observable<CustomFieldsSchemaDto> {
    return this.updateCurrentCustomFieldsSchema$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomFieldsSchemaDto>): CustomFieldsSchemaDto => r.body)
    );
  }

}
